import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { IEnrolledStudentByWeek } from "../../../models/statistics.model";
import Chart from "react-apexcharts";

interface IProps {
  data: IEnrolledStudentByWeek[]|undefined;
}

const ChartContainer: FC<IProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  const getCampusData = (weekData: any) => {
    const campusData: number[] = [];
    for (let i = 1; i <= 52; i++) {
      const week = weekData.find((item: any) => Number(item.weekCode) === i);
      campusData.push(week?.reCount || 0);
    }

    return campusData;
  }

  return (
      <div style={{ width: '100%', height: '70vh', marginTop: 20 }}>
        <Chart
          type="line"
          height="100%"
          options={{
            chart: {
              toolbar: { show: false }
            },
            xaxis: {
              categories: [...Array(52)].map((el, index) => `${index + 1}${t('statistics.studentEnrollWeek.column1')}`),
            }
          }}
          series={data?.map(item => {
            return {
              name: item.campusKorName,
              data: getCampusData(item.weeklyInfo),
            };
          })}
        />
      </div>
  );
}

export default ChartContainer;
